<div class="calendar-card info-card" [style.height]="calendarHeight + 'px'"
     (mouseup)="handleMouseUp()" (mouseleave)="handleMouseLeave()">
  <div class="full-width">
    <div class="calendar-header">

      <div class="btn-cursor" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <mat-icon>calendar_month</mat-icon>
        <input [matDatepicker]="monthPicker" [value]="focusDate" readonly style="width: 0; height: 0; opacity: 0; position: absolute; pointer-events: none;"/>
        <span class="title-default" (click)="monthPicker.open()">{{ monthNames[focusDate.getMonth()] }} {{ focusDate.getFullYear() }}</span>
        <mat-datepicker #monthPicker [startView]="'year'" (monthSelected)="selectMonth($event, monthPicker)"></mat-datepicker>
      </div>

      <div class="nav-buttons">
        <button mat-icon-button (click)="previousMonth()" [disabled]="gridDataLoading">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <button mat-icon-button (click)="nextMonth()" [disabled]="gridDataLoading">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <div class="full-height" fxLayout="column" fxLayoutAlign="space-between start">
    <!-- Calendar Grid -->
    <div class="full-width" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
      <div class="full-width" style="height: 420px">
        <div class="calendar-grid">
          <!-- Day Headers -->
          <div class="day-header" *ngFor="let day of dayHeaders">{{ day }}</div>

          <!-- Calendar Days -->
          <div
            *ngFor="let day of calendarDays; let i = index"
            class="calendar-day"
            [class.preview]="day && dragPreviewDates.includes(formatDateString(day)) && !selectedDates.includes(formatDateString(day))"
            [class.available]="day && isDateAvailable(day)"
            [class.selected]="day && selectedDates.includes(formatDateString(day))"
            [class.unavailable]="day && !isDateAvailable(day)"
            [class.empty]="!day"
            [class.dragging]="day && isDragging && dragStart === formatDateString(day)"
            [class.dragging-over]="day && isDragging"
            (mousedown)="handleMouseDown(day)"
            (mouseenter)="handleMouseEnter(day)"
            (mouseup)="handleMouseUpOnDay(day)"
          >
            <div *ngIf="day" class="day-content">
              <div class="day-number">{{ day }}</div>
              <div *ngIf="getDateLabel(day)"
                   class="date-extra-label">
                {{ getDateLabel(day) }}
              </div>
            </div>
          </div>

          <!--  Loading indicator-->
          @if (gridDataLoading) {
            <div class="grid-loading">
              <mat-spinner diameter="40" mode="indeterminate"></mat-spinner>
            </div>
          }
        </div>
      </div>

      <!-- Legend -->
      <div class="calendar-legend">
        <div class="legend-item">
          <div class="legend-color selected-color"></div>
          <span>Selected dates</span>
        </div>
        <div class="legend-item">
          <div class="legend-color available-color"></div>
          <span>Available dates</span>
        </div>
        <div class="legend-item">
          <div class="legend-color unavailable-color"></div>
          <span>No availability</span>
        </div>
      </div>
    </div>

    <div class="full-width">
      <!-- Selection Info -->
      <div class="selection-info">
        <div class="selection-details">
          <div class="btn-cursor" [style.width]="'350px'" (click)="toggleFullSelectedDates()">
            <strong>{{ selectedDates.length }} date{{ selectedDates.length !== 1 ? 's' : '' }} selected</strong>
            <div class="selected-dates">
              {{ showFullDates ? getSelectedDatesFull() : getSelectedDatesPreview() }}
            </div>
          </div>
          <div class="selection-actions">
            <button mat-button class="button-secondary" (click)="clearSelection()">Clear</button>
            <button mat-flat-button class="button-primary" color="primary" (click)="onConfirmSelected()"
                    [disabled]="disableConfirm || !selectedDates.length">
              {{ bookButtonLabel }}
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
